import { Component, Input } from '@angular/core';


@Component({
  selector: 'lib-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.scss'
})
export class LibIconButtonComponent {

  @Input() color: string = 'primary';
  @Input() disabled: boolean = false;

}
